import * as React from "react"

export type AdminProduct = {
  name?: string | null
  product_group?: string | null
  sku?: string | null
}

type AccessoryLine = { key: string; label: string; amountPence: number }
const money = new Intl.NumberFormat("en-GB", { style: "currency", currency: "GBP" })

export function productGroupLabel(group?: string | null): string {
  if (group === "jetwash") return "Jet washers"
  if (group === "dehumidifier") return "Dehumidifiers"
  if (group === "portable-ac") return "Portable ACs"
  if (group === "fan-heater") return "Fan heaters"
  return group ? group.replaceAll("-", " ") : ""
}

export function bookedAccessories(lineItems: unknown): AccessoryLine[] {
  if (!Array.isArray(lineItems)) return []
  return lineItems.filter((item): item is AccessoryLine => item
    && typeof item.key === "string" && item.key.startsWith("accessory:")
    && typeof item.label === "string" && Number.isInteger(item.amountPence))
}

export function ProductIdentity({ product, showSku = true }: { product?: AdminProduct | null; showSku?: boolean }) {
  const sku = showSku ? product?.sku : null
  return <div className="product-identity">
    <strong>{product?.name || "Product unavailable"}</strong>
    {(product?.product_group || sku) && <small className="product-meta">
      {productGroupLabel(product?.product_group)}{product?.product_group && sku ? " · " : ""}{sku ? `SKU ${sku}` : ""}
    </small>}
  </div>
}

export function AccessorySummary({ lineItems }: { lineItems: unknown }) {
  const accessories = bookedAccessories(lineItems)
  if (!accessories.length) return null
  return <div className="accessory-summary">
    <small className="accessory-summary-label">Accessories</small>
    <ul aria-label="Booked accessories">{accessories.map((item) => <li key={item.key}>
      <span>{item.label}</span><span className="accessory-price">{money.format(item.amountPence / 100)}</span>
    </li>)}</ul>
  </div>
}

export function BookingProductSummary({ product, lineItems }: { product?: AdminProduct | null; lineItems: unknown }) {
  return <div className="booking-product-summary"><ProductIdentity product={product} showSku={false} /><AccessorySummary lineItems={lineItems} /></div>
}
